import { ChevronLeft, ChevronRight, Calendar } from "lucide-react";
import { format, parse, addMonths, subMonths } from "date-fns";
import { ptBR } from "date-fns/locale";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

// FIN-3 — ContasToolbar (T7).
// Esquerda: navegador de mês (← Mês passado | Mês atual | Mês próximo →)
// Direita: slot vazio pra futuras ações (eye toggle ficou no Hero, mais
// próximo do número onde faz sentido).

function _refMonthDate(refMonth) {
  // refMonth: "YYYY-MM"
  try {
    return parse(`${refMonth}-01`, "yyyy-MM-dd", new Date());
  } catch {
    return new Date();
  }
}

function _toIsoMonth(d) {
  return format(d, "yyyy-MM");
}

export default function ContasToolbar({ referenceMonth, onChangeMonth }) {
  const cur = _refMonthDate(referenceMonth);
  const today = new Date();
  const isCurrentMonth = format(cur, "yyyy-MM") === format(today, "yyyy-MM");

  const label = format(cur, "MMMM 'de' yyyy", { locale: ptBR });
  const prev = () => onChangeMonth(_toIsoMonth(subMonths(cur, 1)));
  const next = () => onChangeMonth(_toIsoMonth(addMonths(cur, 1)));
  const goToday = () => onChangeMonth(_toIsoMonth(today));

  return (
    <div className="flex items-center justify-between gap-3" data-testid="contas-toolbar">
      <div className="flex items-center gap-1.5 bg-surface-card-hover/40 border border-subtle rounded-lg px-1 py-0.5">
        <button
          type="button"
          onClick={prev}
          className="p-1.5 rounded-md text-foreground-muted hover:bg-surface-card-hover hover:text-foreground transition-colors"
          aria-label="Mês anterior"
          data-testid="contas-month-prev"
        >
          <ChevronLeft className="w-4 h-4" />
        </button>
        <div
          className="inline-flex items-center gap-2 px-2 text-caption font-medium capitalize text-foreground"
          aria-live="polite"
          data-testid="contas-month-label"
        >
          <Calendar className="w-3.5 h-3.5 text-brand-cyan" aria-hidden="true" />
          {label}
        </div>
        <button
          type="button"
          onClick={next}
          className={cn(
            "p-1.5 rounded-md text-foreground-muted hover:bg-surface-card-hover hover:text-foreground transition-colors",
            isCurrentMonth && "opacity-50 cursor-not-allowed",
          )}
          aria-label="Próximo mês"
          aria-disabled={isCurrentMonth}
          disabled={isCurrentMonth}
          data-testid="contas-month-next"
        >
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
      {!isCurrentMonth && (
        <Button variant="ghost" size="sm" onClick={goToday} data-testid="contas-month-today">
          Hoje
        </Button>
      )}
    </div>
  );
}
